// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stockup[data-v-363145f0]{width:100%;height:100%;resize:both;overflow:auto;position:absolute}", ""]);
// Exports
module.exports = exports;
